import type { RegistryFeature, ValueDraft } from '../api/entitlements'
import '../views/screens.css'

interface ValueEditorProps {
  feature: RegistryFeature
  draft: ValueDraft
  // Accessible name of the input, e.g. "Triggers for Pro".
  label: string
  onChange: (draft: ValueDraft) => void
}

/** One value editor by registry kind: On/Off select, enum select, or a whole number
 * with an "Unlimited" toggle when the key allows null. */
export function ValueEditor({ feature, draft, label, onChange }: ValueEditorProps) {
  if (feature.kind === 'bool') {
    return (
      <select
        className="scr-input scr-input--narrow"
        aria-label={label}
        value={draft.raw}
        onChange={(e) => onChange({ raw: e.target.value, unlimited: false })}
      >
        <option value="true">On</option>
        <option value="false">Off</option>
      </select>
    )
  }
  if (feature.kind === 'enum') {
    return (
      <select
        className="scr-input scr-input--narrow"
        aria-label={label}
        value={draft.raw}
        onChange={(e) => onChange({ raw: e.target.value, unlimited: false })}
      >
        {(feature.values ?? []).map((v) => (
          <option key={v} value={v}>
            {v}
          </option>
        ))}
      </select>
    )
  }
  return (
    <span className="scr-actions">
      <input
        className="scr-input scr-input--narrow"
        type="number"
        min={0}
        step={1}
        inputMode="numeric"
        aria-label={label}
        value={draft.unlimited ? '' : draft.raw}
        disabled={draft.unlimited}
        onChange={(e) => onChange({ raw: e.target.value, unlimited: false })}
      />
      {feature.nullable && (
        <label className="scr-check">
          <input
            type="checkbox"
            checked={draft.unlimited}
            onChange={(e) => onChange({ raw: draft.raw, unlimited: e.target.checked })}
          />
          Unlimited
        </label>
      )}
    </span>
  )
}
